import { readFragment } from "@opensea/graphql";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { getCollectionOverviewUrl } from "@/components/collection/utils";
import { itemUrl } from "@/components/items/utils";
import { SHIPMENT_LOCKED } from "@/constants/assets";
import { useNotificationFragment } from "./use-notification.fragment";
export function useNotification(notificationKey) {
  const notification = readFragment(useNotificationFragment, notificationKey);
  const t = useTranslations("useNotification");
  const {
    resolvedTheme
  } = useTheme();
  function getNotificationProps() {
    let title = t("notificationTitle");
    let content = "";
    let imageUrl = null;
    let href = "/";
    switch (notification?.__typename) {
      case "ItemBoughtNotification":
        title = t("boughtTitle");
        content = notification.item.name;
        imageUrl = notification.item.imageUrl;
        href = itemUrl(notification.item);
        break;
      case "BulkPurchaseNotification":
        title = t("boughtTitle");
        content = t("boughtContent", {
          count: notification.numItems
        });
        imageUrl = notification.representativeItem.imageUrl;
        href = "/profile/items";
        break;
      case "ItemSoldNotification":
        title = t("soldTitle");
        content = notification.item.name;
        imageUrl = notification.item.imageUrl;
        href = itemUrl(notification.item);
        break;
      case "BulkSaleNotification":
        title = t("soldTitle");
        content = t("soldContent", {
          count: notification.numItems
        });
        imageUrl = notification.representativeItem.imageUrl;
        href = "/account";
        break;
      case "MintNotification":
        title = t("mintedTitle");
        content = t("mintedContent", {
          count: notification.numItems,
          collection: notification.collection.name
        });
        imageUrl = notification.collection.imageUrl;
        href = "/profile";
        break;
      case "DropStageReminderNotification":
        title = t("dropStageReminderTitle");
        content = t("dropStageReminderContent", {
          collection: notification.collection.name
        });
        imageUrl = notification.collection.imageUrl;
        href = getCollectionOverviewUrl(notification.collection.slug);
        break;
      case "RewardReadyToClaimNotification":
        if (notification.quest.type === "POINTS_AIRDROP") {
          title = t("shipmentReadyToClaimTitle");
          content = t("shipmentReadyToClaimContent");
          imageUrl = "/img/rewards/notifications/shipment.png";
          href = "/rewards";
        } else {
          title = t("rewardReadyToClaimTitle", {
            tier: notification.quest.tier
          });
          content = t("rewardReadyToClaimContent");
          imageUrl = `/img/rewards/notifications/${notification.quest.tier.toLowerCase()}-${resolvedTheme === "dark" ? "dark" : "light"}.png`;
          href = "/rewards";
        }
        break;
      case "ShipmentReceivedNotification":
        title = t("shipmentReceivedTitle");
        content = notification.shipmentName;
        imageUrl = SHIPMENT_LOCKED;
        href = "/rewards";
        break;
      default:
        break;
    }
    return {
      title,
      content,
      imageUrl,
      href
    };
  }
  const notificationProps = getNotificationProps();
  switch (notification?.__typename) {
    case "ItemBoughtNotification":
    case "ItemSoldNotification":
    case "BulkPurchaseNotification":
    case "BulkSaleNotification":
      return {
        ...notificationProps,
        isRead: notification.isRead,
        price: notification.price,
        occurredAt: notification.occurredAt
      };
    case "RewardReadyToClaimNotification":
    case "MintNotification":
    case "DropStageReminderNotification":
      return {
        ...notificationProps,
        isRead: notification.isRead,
        price: null,
        occurredAt: notification.occurredAt
      };
    case "ShipmentReceivedNotification":
      return {
        ...notificationProps,
        isRead: notification.isRead,
        price: null,
        occurredAt: notification.occurredAt
      };
    default:
      return {
        ...notificationProps,
        isRead: false,
        price: null,
        occurredAt: ""
      };
  }
}